import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

export function flattenErrorMessage(value) {
  if (value == null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map(flattenErrorMessage).filter(Boolean).join('. ');
  }
  if (typeof value === 'object') {
    if (typeof value.message === 'string') {
      return value.message;
    }
    if (typeof value.detail === 'string') {
      return value.detail;
    }
    if (value.message && typeof value.message !== 'string') {
      return flattenErrorMessage(value.message);
    }
    if (value.detail && typeof value.detail !== 'string') {
      return flattenErrorMessage(value.detail);
    }
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '';
    }
  }
  return String(value);
}

export function displayError(errorMessage,title) {

  console.log(errorMessage);
  title = title || '';
  let message = flattenErrorMessage(errorMessage) || 'An unexpected error occurred';
  let code = '';

  if (errorMessage && typeof errorMessage === 'object') {
    code = errorMessage.code ?? errorMessage.detail?.code ?? '';
  }

  let htmlContent = `<b><i>${message}${code !== '' ? ` (Code: ${code})` : ''}</i></b>`;

  if (errorMessage?.detail && Array.isArray(errorMessage.detail) && errorMessage.detail.length > 0) {
    htmlContent += '<ul>';
    errorMessage.detail.forEach(detailItem => {
      // htmlContent += `<li>${detailItem}</li>`;
      htmlContent += '<li>';
      Object.entries(detailItem).forEach(([key, value]) => {
        htmlContent += `<strong>${key}:</strong> ${value}<br>`;
      });
      htmlContent += '</li>';
    });
    htmlContent += '</ul>';
  }
  Swal.fire({
    title: '<img src="/error-icon.png" width="110" height="60"/>' + title,
    html: htmlContent,
    customClass: {
      popup: 'swal-wide',
      icon: 'error'
    },
    })
}

export function displayErrorToast(titleMessage) {
  
  var snackbar = document.getElementById("snackbar");
  var icon =document.getElementById("snackbar-icon");
  if (icon) {
    icon.src= "/error-icon.png";
    icon.height = '40';
    icon.width = '90';
  }
  
  var title = document.getElementById("snackbar-title");
  title.innerText = titleMessage;
  snackbar.className = "show error";
  setTimeout(function(){ snackbar.className = snackbar.className.replace("show", ""); }, 3000);
}

export function displaySuccessToast(titleToast) {
  
    var snackbar = document.getElementById("snackbar");
    var icon =document.getElementById("snackbar-icon");
    icon.src= "./img/success-icon.png";
    icon.height = '50';
    icon.width = '40';
   // snackbar.style.height = '300px';
    var title = document.getElementById("snackbar-title");
    title.innerText = titleToast;
    snackbar.className = "show success";
    setTimeout(function(){ snackbar.className = snackbar.className.replace("show", ""); }, 3000);
      }
    
export function parseBoolean(booleanString) {

  return (booleanString && String(booleanString).toLowerCase() === 'true');
}    
export function parseBooleanToString(booleanValue){
  return (booleanValue?'Yes':'No');
}

export function getApiErrorMessage(error) {
  if (!error) {
    return 'Unexpected error occurred.';
  }
  if (typeof error === 'string') {
    return error;
  }
  const flattened = flattenErrorMessage(error.response?.data ?? error.message ?? error);
  return flattened || error.message || 'Unexpected error occurred.';
}

export function displayApiError(error, title) {
  const payload = error?.response?.data ?? error?.message ?? error;
  displayError(payload, title);
}

export function mapUniqueSelectOptions(values) {
  const seen = new Set();
  const options = [];
  (values || []).forEach((item) => {
    const cleaned = String(item).trim();
    const key = cleaned.toLowerCase();
    if (!cleaned || cleaned === '-' || seen.has(key)) {
      return;
    }
    seen.add(key);
    options.push({ value: cleaned, label: cleaned });
  });
  return options;
}

export function findStateFromGstPortal(stcd, states) {
  if (!stcd) {
    return null;
  }
  const stcdLower = String(stcd).toLowerCase();
  return (states || []).find((state) => {
    const stateLabel = state.value.split('(')[0].trim().toLowerCase();
    return state.value.slice(0, 3).toLowerCase() === String(stcd).slice(0, 3).toLowerCase()
      || stcdLower === stateLabel
      || stcdLower.includes(stateLabel)
      || stateLabel.includes(stcdLower);
  });
}

export function mapGstPortalCustomerFields(result) {
  const addr = result?.pradr?.addr || {};
  return {
    name: result?.tradeNam || result?.lgnm || '',
    address_1: addr.st || '',
    address_2: addr.loc || '',
    address_3: addr.dst || '',
    pincode: addr.pncd || '',
    gst_status: result?.sts || '',
    registration_type: result?.dty || '',
    stcd: addr.stcd || '',
  };
}

export function mapGstRegistrationType(dty) {
  const key = String(dty || '').trim().toLowerCase();
  if (key.includes('composition')) {
    return 'composition';
  }
  if (key.includes('consumer')) {
    return 'consumer';
  }
  if (key.includes('unregistered')) {
    return 'unregistered';
  }
  if (key.includes('regular')) {
    return 'regular';
  }
  return 'unknown';
}

export function buildCustomerFieldsFromGstResult(result, states) {
  const mapped = mapGstPortalCustomerFields(result);
  const st = findStateFromGstPortal(mapped.stcd, states);
  return {
    name: mapped.name,
    address_1: mapped.address_1,
    address_2: mapped.address_2,
    address_3: mapped.address_3,
    pincode: mapped.pincode,
    state: st?.value || '',
    gst_status: mapped.gst_status,
    registration_type: mapGstRegistrationType(mapped.registration_type),
  };
}
